import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i-resume",
  "use": "icon-i-resume-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-i-resume\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path d=\"M38.5 16.5v21.987a1.834 1.834 0 0 1-1.82 1.846H7.32a1.82 1.82 0 0 1-1.82-1.818V5.485c0-.984.82-1.818 1.83-1.818h18.337v11c0 1.012.82 1.833 1.833 1.833h11Zm0-3.667h-9.167v-9.16l9.167 9.16Zm-23.833 0V16.5h5.5v-3.667h-5.5Zm0 7.334v3.666h14.666v-3.666H14.667Zm0 7.333v3.667h14.666V27.5H14.667Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol